/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Вид для поля ввода пароля
   */
  app.PasswordInputView = app.View.extend({
    el: '.password',
    
    events: {
      'click .control_button_password': 'changeVisibility'
    },
    
    /**
     * Изменяет видимость пароля
     */
    changeVisibility: function (event) {
      this.$('.control_button_password').toggleClass('control_button_password_view');
      if (this.$('input').attr('type') === 'password') {
        this.$('input').attr('type', 'text');
      } else {
        this.$('input').attr('type', 'password');
      }
      event.stopPropagation();
    }
  });
})();

}.call(window));